module.exports = __webpack_public_path__ + "r-v3/img/ml_06_00_over.1d53db4e.jpg";